import type { Org, User } from '@/types';

const ORG_ADMIN_ROLES = new Set(['owner', 'admin']);

/**
 * Org admin as platform-api's `require_org_admin` decides it: org role owner
 * or admin, or a platform super-admin. `user.isOwner` alone is narrower (owner
 * only) and is still what owner-only pages such as Members check.
 */
export const isOrgAdmin = (
  user: Pick<User, 'isAdmin'> | null | undefined,
  org: Pick<Org, 'user_role'> | null | undefined,
): boolean =>
  !!user?.isAdmin || ORG_ADMIN_ROLES.has((org?.user_role ?? '').toLowerCase());
